export const CREDENTIAL_TYPES = [
  "DC SLP License",
  "MD SLP License",
  "DC OT License",
  "MD OT License",
  "DC COTA License",
  "MD COTA License",
  "DC SLPA Registration",
  "MD SLPA License",
  "ASHA CCC",
  "NBCOT",
  "RBT",
  "BLS/CPR",
  "Background Check",
];

export const CREDENTIAL_STATUSES = ["Verified", "Pending Verification", "Unverified"];

export const CredentialFields = ({ value, onChange, providers, prefix, includeProvider = true }) => {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <>
      {includeProvider && (
        <label>
          Provider
          <select data-testid={`${prefix}-provider-select`} required value={value.provider_id} onChange={(e) => set({ provider_id: e.target.value })}>
            <option value="">Select provider</option>
            {providers.map((provider) => <option key={provider.id} value={provider.id}>{provider.name} · {provider.discipline}</option>)}
          </select>
        </label>
      )}
      <label>
        Credential type
        <select data-testid={`${prefix}-type-select`} required value={value.credential_type} onChange={(e) => set({ credential_type: e.target.value })}>
          <option value="">Select type</option>
          {CREDENTIAL_TYPES.map((type) => <option key={type}>{type}</option>)}
        </select>
      </label>
      <label>
        License number
        <input data-testid={`${prefix}-license-number-input`} value={value.license_number || ""} onChange={(e) => set({ license_number: e.target.value })} />
      </label>
      <label>
        Issuing state
        <input data-testid={`${prefix}-issuing-state-input`} value={value.issuing_state || ""} maxLength={40} placeholder="DC, MD…" onChange={(e) => set({ issuing_state: e.target.value })} />
      </label>
      <label>
        Issue date
        <input data-testid={`${prefix}-issue-date-input`} type="date" value={value.issue_date || ""} onChange={(e) => set({ issue_date: e.target.value })} />
      </label>
      <label>
        Expiration date
        <input data-testid={`${prefix}-expiration-input`} required type="date" value={value.expiration_date || ""} onChange={(e) => set({ expiration_date: e.target.value })} />
      </label>
      <label>
        Board lookup link
        <input data-testid={`${prefix}-board-url-input`} type="url" value={value.board_lookup_url || ""} placeholder="https://…" onChange={(e) => set({ board_lookup_url: e.target.value })} />
      </label>
      <label>
        Verification status
        <select data-testid={`${prefix}-status-select`} value={value.document_status} onChange={(e) => set({ document_status: e.target.value })}>
          {CREDENTIAL_STATUSES.map((s) => <option key={s}>{s}</option>)}
        </select>
      </label>
      <label className="credential-check-label">
        <input data-testid={`${prefix}-required-toggle`} checked={!!value.required_for_assignment} type="checkbox" onChange={(e) => set({ required_for_assignment: e.target.checked })} /> Required before assignment
      </label>
    </>
  );
};
